module.exports = __webpack_public_path__ + "static/media/MPLAD.7df03026.svg";